import React from 'react';
import logo from './logo.svg';
import './Assets/Style/Style.css';
import { ToastContainer } from 'react-toastify';
import AppRoutes from './AppRoutes/AppRoutes';
import { useSelector } from 'react-redux';
import { RootState } from './Redux/store';

function App() {
  const { loading } = useSelector((state: RootState) => state.loading)
  return (
    <div className="App">
      <ToastContainer />
      <AppRoutes />
      {loading && (
        <div className="spinner-overlay">
          <div className="spinner"></div>
        </div>
      )}
    </div>
  );
}

export default App;
